export class BaseIntervalInputParams {
}
